





























































import { OrderResult, SuccessOrderResult } from '@/models/order/completed/order-result'
import { Contact, Delivery } from '@/models/order/order'
import { OrderSummary } from '@/models/order/summary'
import _ from 'lodash'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop, Watch } from 'vue-property-decorator'

import BehaviorConfig from '@/models/app-config/behavior/behavior'
import { CartScopeEq } from '@/models/cart/group/scope'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'

import LoadingMixin, { Status } from '@spa/mixins/loading'
import { PluginMixin } from '@spa/mixins/plugin'
import { CartItem } from '@spa/store/modules/cart/types'
import { Route } from 'vue-router'

import ContactViewItem from '@spa/components/organisms/contact/ViewItem.vue'
import OrderResultList from './completed/OrderResultList.vue'
import CompletedSummary from './completed/Summary.vue'

import FreeAreaService from '@/services/free-area/free-area'
import MATag from '@/util/ma-tag'
import CALinkTag from '@/util/ma-tag/ca-link/index'

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteLeave',
])

@Component({
  components: {
    ContactViewItem,
    CompletedSummary,
    OrderResultList,
  },
  mixins: [
    LoadingMixin,
  ],
})
export default class OrderComplete extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  freeAreaService: FreeAreaService

  @Prop({ required: true })
  behavior: BehaviorConfig

  status: Status = Status.Pending

  topMessage = '&nbsp;'

  maTag: MATag | null = null

  get summary(): OrderSummary {
    return this.$store.getters['subscriptionConfirm/summary']
  }

  get orderResults(): OrderResult[] {
    return this.$store.getters['subscriptionConfirm/allOrderResults']
  }

  get successedOrders(): SuccessOrderResult[] {
    return this.$store.getters['subscriptionConfirm/succeedOrderResults']
  }

  /**
   * サマリーとして表示する配送情報
   */
  get representiveDelivery(): Delivery {
    return this.$store.getters['subscriptionConfirm/delivery']
  }

  get representiveDeliveryContact(): Contact {
    return this.representiveDelivery.contact
  }

  get isFirstShareItem(): boolean {
    return this.$store.getters['user/getFirstShareItem']
  }

  get isLoading(): boolean {
    return this.$store.state.view.isLoading
  }

  formatSizeAndColor(item: CartItem) {
    return _.compact([item.size, item.color]).join('/')
  }

  beforeRouteEnter(to: Route, from: Route, next) {
    const { path: fromPath } = from
    const skuId = to.params.sku_id

    const routingAfterConfirmApply = fromPath === `/order/subscription/${skuId}`
    const routingByPageReload = fromPath === `/order/subscription/${skuId}/complete`

    if (
      ! (routingAfterConfirmApply || routingByPageReload)
    ) {
      next({
        path: `/order/subscription/${skuId}`,
        replace: true,
      })
    }

    next()
  }

  beforeRouteLeave(_to, _from, next) {
    this.$store.dispatch('orderConfirm/setComplete', null)

    next()
  }

  async created() {
    await this.$store.dispatch('view/startLoading')
    await this.loadFreeAreaContents()
    await this.$store.dispatch('view/stopLoading')
  }

  async loadFreeAreaContents(): Promise<void> {
    const [topMessageFreeArea] = await this.freeAreaService.fetch()
    if (topMessageFreeArea) {
      this.topMessage = topMessageFreeArea.contentForMobile
    } else {
      this.topMessage = ''
    }
  }

  mounted() {
    EventBusForThirdParty.getInstance().publish('purchase-subscription', {
      successOrderResultList: this.successedOrders,
    })
  }

  @Watch('orderResults', { immediate: true })
  updateMATag(): void {
    if (!this.maTag) this.maTag = new CALinkTag()

    this.maTag.fkuIds = _.flatten(this.orderResults.map(result => (
      result.order.cartItems
        .filter(item => !(item.isChild || item.isNovelty))
        .map(item => item.fkuId)
    )))

    this.maTag.setHtmlMetaElementTo(document)
  }
}
